module.exports = __webpack_public_path__ + "img/base_restauration_crepe.2ed2a55b.svg";